import { useId } from 'react';

const BASE = `w-full rounded border border-line bg-surface px-3 py-2 text-base
  text-ink placeholder:text-muted disabled:opacity-60 md:text-sm`;

// Etichetta sempre visibile (mai solo placeholder), aiuto ed errore legati via aria.
export default function Field({ label, hint, error, required, children, className = '', ...resto }) {
  const id = useId();
  const hintId = hint ? `${id}-hint` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  const descritto = [hintId, errorId].filter(Boolean).join(' ') || undefined;

  const controllo = typeof children === 'function'
    ? children({ id, 'aria-describedby': descritto, 'aria-invalid': !!error || undefined, className: BASE, required })
    : <input id={id} aria-describedby={descritto} aria-invalid={!!error || undefined}
             required={required} className={BASE} {...resto} />;

  return (
    <div className={`space-y-1 ${className}`}>
      <label htmlFor={id} className="block text-sm font-medium text-ink">
        {label}{required && <span className="text-danger" aria-hidden> *</span>}
      </label>
      {controllo}
      {hint && <p id={hintId} className="text-xs text-muted">{hint}</p>}
      {error && <p id={errorId} role="alert" className="text-xs text-danger">{error}</p>}
    </div>
  );
}

export { BASE as classeCampo };
